import { useRewardsProgramData, useUser } from "@/queries/user"
import { Pressable } from "react-native"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { Body, H3, Small } from "@/components/standard/BFText"
import {
  LevelDiscount,
  type LevelType,
} from "@/screens/rewards/components/LevelDiscount"
import { ProgramInfoPopup } from "@/screens/rewards/components/ProgramInfoPopup"
import { useState } from "react"

export const SaveOnFutureDeals = () => {
  const { data: rewardsProgramData } = useRewardsProgramData()
  const { data: user } = useUser()
  const [showProgramDetails, setShowProgramDetails] = useState(false)

  const balance = user?.me?.lastPointTransaction?.balance || 0
  const tiers = rewardsProgramData?.tiers

  const filteredTiers =
    tiers?.filter((t) => t?.minPointsRequired! > (balance || 0)) || []

  if (tiers && balance >= tiers[tiers.length - 1]?.minPointsRequired!) {
    return null
  }

  return (
    <Vertical className={"my-5"}>
      <Horizontal className={"justify-between mb-5"}>
        <H3>Save on Future Deals</H3>
        <Pressable
          testID={"open-future-deals-details"}
          onPress={() => {
            setShowProgramDetails(true)
          }}
        >
          <Small className={"underline text-calm-blue"}>
            View All Discounts
          </Small>
        </Pressable>
      </Horizontal>
      {balance < 5000 && (
        <Body className={"text-midnight-blue"}>
          Close your first deal with Backflip to start earning bps discounts on
          future closes.
        </Body>
      )}
      <Vertical className={"gap-0"}>
        {filteredTiers.map((tier) => (
          <LevelDiscount key={tier!.name} level={tier!.name as LevelType} />
        ))}
      </Vertical>
      <ProgramInfoPopup
        visible={showProgramDetails}
        onClose={() => {
          setShowProgramDetails(false)
        }}
      />
    </Vertical>
  )
}
